import { ComponentType } from 'react'

import { ConfigProvider } from 'antd'
import ruRu from 'antd/locale/ru_RU'

import { defaultTheme } from '@ant-design/compatible'
import dayjs from 'dayjs'

dayjs.locale('ru')

export default (WrappedComponent: ComponentType) => {
  const Component = ({ ...props }) => (
    <ConfigProvider
      locale={ruRu}
      theme={{
        ...defaultTheme,
        components: {
          Button: {
            colorPrimary: '#2F54EB;',
          },
        },
      }}
    >
      <WrappedComponent {...props} />
    </ConfigProvider>
  )

  return Component
}
